import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, tap } from 'rxjs/operators';
import * as BlogCategoryApiActions from '@app/modules/blog-category/actions/blog-category-api.actions';
import { Store } from '@ngrx/store';
import { State } from '@app/reducers';
import { BlogCategoryService } from "@app/modules/blog-category/services/blog-category.service";

export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const blogCategoryService = inject(BlogCategoryService);
    const router = inject(Router);
    const store = inject(Store<State>);

    return blogCategoryService.get(route.params['id']).pipe(
        map(blogCategory => BlogCategoryApiActions.GetSuccess(blogCategory)),
        tap((action: any) => store.dispatch(action)),
        map(blogCategory => !!blogCategory),
        catchError(() => {
            return router.navigate(['/not-found']);
        })
    );
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);
